import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=0d21e9c4&scoped=true&"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationComplete.vue?vue&type=style&index=0&id=0d21e9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21e9c4",
  null
  
)

export default component.exports